<template>
  <div class="text-center space-y-2">
    <h1 class="">404</h1>
    <div class="text-muted-foreground">Oh no! What you were looking for was not found.</div>
    <div class="">
      If you need help please contact us at
      <a href="mailto:support@myoutdesk.com">
        <Button size="sm" variant="link" class="p-0">support@myoutdesk.com</Button>
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { Button } from '@/components/ui/button';
</script>
